import { useEffect, useState } from 'react';

// Missing on the server and in some test environments, hence the guard.
const getList = (query: string): MediaQueryList | null =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;

export function useMediaQuery(query: string): boolean {
  const [isMatched, setIsMatched] = useState(() => getList(query)?.matches ?? false);

  useEffect(() => {
    const list = getList(query);
    if (!list) return undefined;

    setIsMatched(list.matches);

    const handleChange = (event: MediaQueryListEvent): void =>
      setIsMatched(event.matches);

    // Safari below 14 only has the deprecated addListener/removeListener pair.
    if (typeof list.addEventListener === 'function') {
      list.addEventListener('change', handleChange);
      return () => list.removeEventListener('change', handleChange);
    }

    list.addListener(handleChange);
    return () => list.removeListener(handleChange);
  }, [query]);

  return isMatched;
}
